<div style="width: calc(720px + 1rem);"></div>
<h4>
  <span>
    {{ selectedLottery.event.date.date | date: 'dd.MM.yyyy' }}
    {{ selectedLottery.event.getFormattedEventName() }}
  </span>
</h4>
<form [formGroup]="lotteryExecutionForm" (ngSubmit)="formSubmit(lotteryExecutionForm)" id="lotteryExecutionForm" *ngIf="!loading">
  <div class="esf-submit-row__item">
    <button type="button" class="esf-button esf-button--simple" (click)="applyLastUsedFilters()" *ngIf="tixxSelectService.savedFilters()">
      <svg class="esf-icon esf-button__icon" width="16" height="16">
        <use xlink:href="#esf-icon-clock-redo-small"></use>
      </svg>
      <span class="esf-button__icon-text" i18n='@@general.button.applyLastFilters'>Apply last used filters</span>
    </button>
  </div>
  <h4 class="esf-heading esf-heading--low-level" i18n="@@general.formLabel.ticketSelection">Ticket Selection</h4>
  <div class="esf-form-item">
    <div class="esf-check-radio">
      <input class="esf-check-radio__input esf-check-radio--check__input"
             type="checkbox"
             [(ngModel)]="specificTicketCount"
             [ngModelOptions]="{standalone: true}"
             id="specificTickets"
             name="specificTickets">
      <label class="esf-check-radio__label esf-check-radio--check__label"
             for="specificTickets"
             i18n="@@general.label.specificTicketCount">Specific ticket count</label>
    </div>
  </div>
  <div class="esf-form-group">
    <div class="esf-form-item esf-form-item--1-2">
      <div class="name-prefix-wrapper">
        <div class="esf-check-radio">
          <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="ticketRequestType" type="radio" id="primary" value="primary">
          <label class="esf-check-radio__label esf-check-radio--radio__label"
                 for="primary"
                 i18n='@@general.formLabel.firstChoice'>First choice</label>
        </div>
        <div class="esf-check-radio">
          <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="ticketRequestType" type="radio" id="secondary" value="secondary">
          <label class="esf-check-radio__label esf-check-radio--radio__label"
                 for="secondary"
                 i18n='@@general.formLabel.secondChoice'>Second choice</label>
        </div>
      </div>
    </div>
    <div app-form-field-stepper
         *ngIf="specificTicketCount"
         [control]="lotteryExecutionForm.controls['ticketCount']"
         [label]="flTranslations.i18nMaxTicketCount">
    </div>
  </div>
  <div app-form-field-select
       [array]="priceCategoriesList"
       [useNgValue]="true"
       [valueKey]="'id'"
       [textKey]="'name'"
       [control]="lotteryExecutionForm.controls['priceCategoryId']"
       [label]="flTranslations.i18nPriceCategory">
  </div>

  <div app-form-field-multiselect
       [control]="lotteryExecutionForm.get('ticketReductions')"
       [label]="flTranslations.i18nPriceReduction"
       [multiselectData]="multiselectDataReductions">
  </div>

  <h4 class="esf-heading esf-heading--low-level" i18n="@@general.formLabel.requestOptions">Request options</h4>

  <label class="esf-form-item__label" i18n="@@general.formLabel.submissionTimeFrame">Submission time frame</label>

  <div class="esf-form-group">

    <div app-form-field-datepicker
         [enableTime]="true"
         class="esf-form-item--1-2"
         [control]="lotteryExecutionForm.controls['submissionStartDate']"
         [placeholder]="flTranslations.i18nStart"
         [label]="flTranslations.i18nStart">
    </div>

    <div app-form-field-datepicker
         [enableTime]="true"
         class="esf-form-item--1-2"
         [control]="lotteryExecutionForm.controls['submissionEndDate']"
         [placeholder]="flTranslations.i18nDeadline"
         [label]="flTranslations.i18nDeadline">
    </div>
  </div>

  <div app-form-field-checkbox
       [control]="lotteryExecutionForm.controls['contiguousSeating']"
       [label]="flTranslations.i18nOnlyContiguousSeatingRequests"
       (inputValueChange)="confirmContiguousSeating($event)">
  </div>

  <div app-form-field-checkbox
       [control]="lotteryExecutionForm.controls['priceDeviationAllowed']"
       (inputValueChange)="priceDeviationToggle($event)"
       [label]="flTranslations.i18nPriceDeviationAllowed">
  </div>

  <div class="esf-form-item" *ngIf="lotteryExecutionForm.controls['priceDeviationAllowed'].value">
    <div class="name-prefix-wrapper">
      <div class="esf-check-radio">
        <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="priceDeviation" type="radio" id="higher" value="higher">
        <label class="esf-check-radio__label esf-check-radio--radio__label"
               for="higher"
               i18n='@@general.formLabel.higherPriceValue'>Higher price value</label>
      </div>
      <div class="esf-check-radio">
        <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="priceDeviation" type="radio" id="lower" value="lower">
        <label class="esf-check-radio__label esf-check-radio--radio__label"
               for="lower"
               i18n='@@general.formLabel.lowerPriceValue'>Lower price value</label>
      </div>
    </div>
  </div>

  <div app-form-field-checkbox
       [control]="lotteryExecutionForm.controls['specialRequirement']"
       [label]="flTranslations.i18nOnlyOptionalCheckbox">
  </div>

  <h4 class="esf-heading esf-heading--low-level" i18n="@@general.formLabel.customerLimitations">Customer limitations</h4>

  <div app-form-field-checkbox
       [control]="lotteryExecutionForm.controls['activeMembers']"
       [label]="flTranslations.i18nOnlyActiveMembers">
  </div>

  <div app-form-field-checkbox
       [control]="lotteryExecutionForm.controls['negativeLuckBalance']"
       [label]="flTranslations.i18nNegativeFairnessRatio">
  </div>

  <div app-form-field-multiselect
       [control]="lotteryExecutionForm.get('attributes')"
       [label]="flTranslations.i18nAttributes"
       [multiselectData]="multiselectDataAttributes">
  </div>

  <div class="esf-form-group">
    <div app-form-field-number
         [isCurrency]="false"
         class="esf-form-item--1-4"
         [control]="lotteryExecutionForm.controls['postalCodeRangeFrom']"
         (inputValueChange)="checkPostCodeFrom($event)"
         [label]="flTranslations.i18nPostCodeFrom">
    </div>
    <div app-form-field-number
         [isCurrency]="false"
         class="esf-form-item--1-4"
         [control]="lotteryExecutionForm.controls['postalCodeRangeTo']"
         (inputValueChange)="checkPostCodeTo($event)"
         [label]="flTranslations.i18nPostCodeTo">
    </div>
    <div app-form-field-text-generic
         class="esf-form-item--1-2"
         [control]="lotteryExecutionForm.controls['city']"
         [label]="flTranslations.i18nCity">
    </div>
  </div>

  <app-submit-row-buttons style="max-width: calc(720px + 2rem);"
                          [form]="'lotteryExecutionForm'"
                          [spinnerName]="spinnerName"
                          [cancelButtonText]="buttonsTranslations.i18nResetFilterSettings"
                          [submitButtonText]="buttonsTranslations.i18nFilterOpenRequests"
                          (cancelButton)="reset()">
  </app-submit-row-buttons>
</form>

<app-spinner [(show)]="loading"></app-spinner>

<ng-container *ngIf="executionSummary && !spinnerService.isShowing(spinnerName)">

  <div class="esf-info-tile esf-info-tile--static summary-margin">
    <div class="esf-info-tile__content">
      <div class="esf-execution__info">
        <div>
          <div>
            <div class="icon-and-text">
              <span class="esf-icon--info large-text">{{ executionSummary.numberOfRequests }}</span>
              <svg class="esf-icon esf-icon--info icon-margin" width="32" height="32">
                <use xlink:href="#esf-icon-user-48"></use>
              </svg>
            </div>
            <h5 class="esf-icon--info"
                i18n="@@lotteryExecution.summaryTitle.requests">{ executionSummary.numberOfRequests, plural, =1 { Request } other { Requests }}</h5>
          </div>
        </div>
        <div>
          <div>
            <div class="icon-and-text">
              <span class="large-text">{{ executionSummary.numberOfRequestedTickets }}</span>
              <svg class="esf-icon icon-margin" width="32" height="32">
                <use xlink:href="#esf-icon-ticket-48"></use>
              </svg>
            </div>
            <h5 i18n="@@lotteryExecution.summaryTitle.tickets">{ executionSummary.numberOfRequestedTickets, plural, =1 { Ticket } other { Tickets }}</h5>
          </div>
        </div>
        <div *ngIf="!this.priceDeviationCategories.length">
          <div class="icon-and-text">
            <span class="esf-icon--success large-text">{{ executionSummary.priceCategoryCapacity }}</span>
            <svg class="esf-icon esf-icon--success icon-margin" width="32" height="32">
              <use xlink:href="#esf-icon-sofa-48"></use>
            </svg>
          </div>
          <h5 class="esf-icon--success"
              i18n="@@lotteryExecution.summaryTitle.freeSeats">{ executionSummary.priceCategoryCapacity, plural, =1 { Free seat } other { Free seats }}</h5>
        </div>
      </div>

      <div class="esf-execution__data data-margin">
        <button (click)="openResultsTable()"
                class="esf-button esf-button--simple"
                [disabled]="executionSummary.numberOfRequests === 0">
          <svg class="esf-icon esf-button__icon" width="16" height="16">
            <use xlink:href="#esf-icon-calendar-grid"></use>
          </svg>
          <span class="esf-button__icon-text" i18n="@@general.button.openResultsTable">Open result table</span>
        </button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="priceDeviationCategories.length">
    <h4 i18n="@@lotteryExecution.subHeading.assignNewPrices">Assign new prices and reductions to filtered requests</h4>
    <ng-container *ngFor="let category of priceDeviationCategories; let i = index">
      <div class="flex-categories">
        <span style="font-weight: bold;">
          <a class="esf-tag" [style.backgroundColor]="category.color"></a>
          {{ category.name }}
        </span>
        <div app-form-field-select
             #priceDeviationCategory
             style="max-width: 20rem; margin-bottom: 0;"
             (valueChanged)="updateFormCategory($event, i)"
             [array]="priceCategoriesList"
             [preselectedValue]="category.id"
             [valueKey]="'id'"
             [textKey]="'nameAndSeats'"
             [id]="'priceCategory' + i">
        </div>
      </div>

      <hr>

      <ng-container *ngFor="let reduction of category.assignedReductions; let x = index">
        <div class="flex-categories">
          <span>
            {{ reduction.fullName }}
          </span>
          <div app-form-field-select
               style="max-width: 20rem; margin-bottom: 0;"
               (valueChanged)="updateFormReductions($event, i, x)"
               [array]="getCategory(priceDeviationCategory)"
               [valueKey]="'id'"
               [textKey]="'fullName'"
               [id]="'priceReduction' + i + x">
          </div>
        </div>
      </ng-container>

      <div style="height: 2rem;"></div>

    </ng-container>

  </ng-container>

  <div style="display: flex; justify-content: flex-end; margin-right: 1rem; margin-top: 2rem;">
    <app-submit-row-buttons style="max-width: calc(720px + 2rem);"
                            [showCancel]="false"
                            [isFieldValid]="atLeastOne"
                            [submitButtonText]="buttonsTranslations.i18nNext"
                            (submitButton)="nextStep()">
    </app-submit-row-buttons>
  </div>
</ng-container>
